import { PageKey } from '~/constants/page'
import { LS_KEY, useGlobalSuckState } from '~/hooks/useGlobalSuckState'

export const usePublishSuccess = () => {
  const router = useRouter()

  // 操蛋的逻辑
  const { forceTopUserShow } = useGlobalSuckState()
  if (!localGetItem(LS_KEY.FORCE_TOP_USER_SHOW)) {
    forceTopUserShow.value = true
  }

  const userInfo = useUserInfo()
  const { $t } = useNuxtApp()
  message.success({
    content: () => (
      <span>
        {$t('fa-bu-shen-qing-yi-ti-jiao-dian-ji-cha-kan-shen-he-jin-du')}
        <a
          class={'ml-[4px]'}
          onClick={() => {
            router.push({
              name: PageKey.PERSONAL_PAGE,
              params: { key: userInfo.value?.organization_id },
              query: { tab: 'reviewing' },
            })
          }}
        >
          {$t('dian-ji-cha-kan')}
        </a>
      </span>
    ),
  })
}
